import * as React from 'react';
import { StyledHeaderBar, StyledLeftHeaderWrapper, StyledToolbar } from './header-bar.styles';
import { useNavigation } from '@/navigation/navigation.provider';
import { UserOptionsDisplay } from '@/search-for-retail/controls/user-display';
import { NavigationDrawerLogo } from '@/navigation/drawer/partials';
import { useGoHome } from '@/routing/hooks/utils';
import { ContextSelectorsContainer } from '@/search-for-retail/generic/page-context-selection';
import { hasEnrichAccessOnly } from '@/utils/environment';
import { NavigationType } from '@/navigation/types';
import { BrainStudioIcon } from '@/components/icons';
export const HeaderBar = () => {
    const { isDrawerOpen, setNavigationType } = useNavigation();
    const goHome = useGoHome();
    return (<StyledHeaderBar enableColorOnDark color="secondary" position="static">
      <StyledToolbar disableGutters>
        <StyledLeftHeaderWrapper>
          <NavigationDrawerLogo open={isDrawerOpen} text="Brain Studio" icon={<BrainStudioIcon primary="white" secondary="white" subtitle="white" accent="white"/>} linkDisabled={hasEnrichAccessOnly} onLogoClick={() => {
            goHome();
            setNavigationType(NavigationType.PRIMARY);
        }}/>
          <ContextSelectorsContainer />
        </StyledLeftHeaderWrapper>
        <UserOptionsDisplay />
      </StyledToolbar>
    </StyledHeaderBar>);
};
export default HeaderBar;
